import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { audience } from "@/mocks/criacao-sites";

export default function AudienceSection() {
  return (
    <section className="bg-foreground-950 py-16 text-background-50 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Para quem é"
          badgeIcon="ri-group-line"
          tone="dark"
          title="Para empresas que querem uma presença digital profissional"
          description="Seja para começar do zero ou melhorar uma estrutura existente, a NXHOST atende diferentes tipos de negócio."
        />

        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {audience.map((item, index) => (
            <Reveal key={item.label} delay={index * 40}>
              <div className="flex h-full items-center gap-3 rounded-xl border border-background-50/10 bg-background-50/5 px-4 py-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-500/15 text-accent-300">
                  <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <span className="text-sm font-medium text-background-100">{item.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}